module.exports = __webpack_public_path__ + "static/media/generic-preview.c9e3808a.png";